/* ================================================================
   TARASHE FOOTER — Accordion + Scroll Hint JS
   File: assets/tarashe-footer.js
================================================================ */

(function () {
  'use strict';

  /* ── Trust strip scroll hint ── */
  function initTrustScrollHint() {
    var trust = document.querySelector('.tarashe-footer__trust');
    if (!trust) return;
    if (window.innerWidth >= 768) return;

    trust.addEventListener('scroll', function () {
      if (trust.scrollLeft > 20) {
        trust.classList.add('is-scrolled');
      }
    }, { passive: true });
  }

  /* ── Accordion ── */
  function initAccordion() {
    var triggers = document.querySelectorAll('.tarashe-footer__accordion-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel   = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        /* Close all other open panels */
        triggers.forEach(function (t) {
          if (t === trigger) return;
          t.setAttribute('aria-expanded', 'false');
          var pid = t.getAttribute('aria-controls');
          var p   = pid ? document.getElementById(pid) : null;
          if (p) p.classList.remove('is-open');
        });

        /* Toggle current */
        var nowOpen = !isOpen;
        trigger.setAttribute('aria-expanded', String(nowOpen));
        panel.classList.toggle('is-open', nowOpen);
      });
    });
  }

  function init() {
    initTrustScrollHint();
    initAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.tarashe-footer')) {
      init();
    }
  });

})();